<div
  *ngIf="user.email == 'admin@zitemedia.com' || user.email == 'buyer@jetfueltenders.com' || user.email == 'supplier1@jetfueltenders.com' || user.email == 'supplier2@jetfueltenders.com'|| user.email == 'supplier3@jetfueltenders.com'"
  class="bg-primary container-fluid">
  <div class="row align-items-center">
    <div class="col-12 col-sm-4 text-white">
      <div class="p-2" *ngIf="user.email == 'admin@zitemedia.com'">Demo Mode: Admin View</div>
      <div class="p-2" *ngIf="user.email == 'buyer@jetfueltenders.com'">Demo Mode: Airline View</div>
      <div class="p-2"
        *ngIf="user.email == 'supplier1@jetfueltenders.com' ||  user.email == 'supplier2@jetfueltenders.com'||  user.email == 'supplier3@jetfueltenders.com'">
        Demo Mode: Fuel Supplier View</div>
    </div>
    <div class="col-12 col-sm-4 text-start text-sm-center text-white">
      <div class="px-2">
        <div class="d-none d-xl-block"><span class="badge bg-light text-dark">Screen: XL</span></div>
        <div class="d-none d-lg-block d-xl-none"><span class="badge bg-light text-dark">Screen: LG</span></div>
        <div class="d-none d-md-block d-lg-none"><span class="badge bg-light text-dark">Screen: M</span></div>
        <div class="d-none d-sm-block d-md-none"><span class="badge bg-light text-dark">Screen: SM</span></div>
        <div class="d-block d-sm-none"><span class="badge bg-light text-dark">Screen: Defaut</span></div>
      </div>
    </div>
  </div>
</div>

<nav class="navbar navbar-expand-lg navbar-dark bg-dark px-2 py-0">
  <!-- The logo (ui-rules §6b, D-373): the same component as the v2 bar. -->
  <a *ngIf="!user.isAuthenticated()" class="navbar-brand me-6 text-white" href="{{ landingUrl }}" aria-label="Jet Fuel Tenders">
    <jft-v2-brand></jft-v2-brand>
  </a>
  <a *ngIf="user.isAuthenticated()" class="navbar-brand me-6 text-white" routerLink="/" aria-label="Jet Fuel Tenders">
    <jft-v2-brand></jft-v2-brand>
  </a>

  <button class="navbar-toggler border-0" type="button" (click)="toggleMenu()"
    aria-controls="navbarToggler" [attr.aria-expanded]="menuOpen" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Notifications live in the bar (right-aligned) on mobile instead of the
       drawer. Single instance — see isMobile in the component. -->
  <jft-notifications *ngIf="isMobile && user.isAuthenticated() && !user.isNoAccess()" class="navbar-notif"></jft-notifications>

  <!-- Backdrop for the mobile drawer; tapping it closes the menu. -->
  <div class="navbar-backdrop" [class.show]="menuOpen" (click)="closeMenu()"></div>

  <div class="collapse navbar-collapse" id="navbarToggler" [class.show]="menuOpen">
    <ul *ngIf="user.isAuthenticated()" class="navbar-nav me-auto mt-2 mt-lg-0">
      <!-- Tender menus: never for No Access, who sees Settings only. -->
      <ng-container *ngIf="!user.isNoAccess()">
      <li *ngIf="company.isBuyer() && user.canManage()" class="nav-item">
        <button *ngIf="!company.isChild" class="btn btn-dark"
          type="submit"><create-tender-button data-testid="create-tender"></create-tender-button></button>
      </li>
      <li class="nav-item"
        *ngIf="company.isSupplier() && !user.isSuperAdmin() && company.hasSupplierPremium()">
        <button class="btn btn-dark" type="submit">
          <create-external-tender-button></create-external-tender-button>
        </button>
      </li>
      <li class="nav-item">
        <a *ngIf="!user.isSuperAdmin()" class="nav-link"
          [routerLink]="company.isSupplier() ? '/supplier/tenders' : '/tenders'" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">Tenders
          <!--tender-actions-counter></tender-actions-counter-->
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/contacts" routerLinkActive="active" *ngIf="company.isBuyer()">Contacts</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/awarded-contracts" routerLinkActive="active" *ngIf="company.isBuyer()">Awarded
          Contracts</a>
      </li>
      <!-- Supplier subscription-based items -->
      <li class="nav-item"
        *ngIf="company.isSupplier() && !user.isSuperAdmin() && company.hasSupplierPremium()">
        <a class="nav-link" routerLink="/supplier/customers" routerLinkActive="active">Customers</a>
      </li>
      <li class="nav-item" *ngIf="company.isSupplier() && !user.isSuperAdmin()">
        <a class="nav-link" routerLink="/supplier/supply-locations" routerLinkActive="active">Supply Locations</a>
      </li>
      <li *ngIf="company.isSupplier() && !user.isSuperAdmin()" ngbDropdown class="nav-item">
        <a ngbDropdownToggle class="nav-link dropdown-toggle pointer" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}">
          Reports
        </a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
          <!-- Accessible Item -->
          <a class="dropdown-item" routerLink="/supplier/reports/volume-projections" routerLinkActive="active"
            *ngIf="user.settings?.view_reports">
            Volume Projections
          </a>
          <!-- Disabled Item -->
          <a class="dropdown-item disabled text-muted" aria-disabled="true" *ngIf="!user.settings?.view_reports"
            title="View Reports Permission Required">
            Volume Projections <i class="bi bi-lock-fill ms-1"></i>
          </a>

          <!-- Tender Performance -->
          <a class="dropdown-item" routerLink="/supplier/reports/tender-performance" routerLinkActive="active"
            *ngIf="user.settings?.view_reports">
            Tender Performance
          </a>
          <a class="dropdown-item disabled text-muted" aria-disabled="true" *ngIf="!user.settings?.view_reports"
            title="View Reports Permission Required">
            Tender Performance <i class="bi bi-lock-fill ms-1"></i>
          </a>
        </div>
      </li>
      </ng-container>
      <li class="nav-item" *ngIf="user.canEditBusinessSettings()">
        <a class="nav-link" routerLink="/account" routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">Settings</a>
      </li>

      <!-- Admin Navigation: the old admin is retired; everything lives in admin v2. -->
      <li class="nav-item" *ngIf="user.isSuperAdmin()">
        <a class="nav-link" routerLink="/admin-v2/overview" routerLinkActive="active" data-testid="navbar-admin">Admin</a>
      </li>
    </ul>
    <div *ngIf="user.isAuthenticated()" class="navbar-nav my-2 my-lg-0">
      <div class="nav-item" *ngIf="!user.isSuperAdmin()">
        <a class="nav-link link-white" href="{{ docsUrl }}/" target="_blank">
          Docs
        </a>
      </div>
      <div class="nav-item" *ngIf="!user.isSuperAdmin()">
        <a class="nav-link link-white d-inline-flex align-items-center gap-1"
           routerLink="/access/contact-support" target="_blank">
          Contact Support
          <ng-icon name="lucideMessageCircleQuestion"></ng-icon>
        </a>
      </div>
      <jft-notifications *ngIf="!isMobile && !user.isNoAccess()"></jft-notifications>
    </div>
    <div *ngIf="user.isAuthenticated()" class="navbar-nav navbar-account">
      <!-- Mobile: flattened, always-visible account section (Sign Out is the
           logout icon on the identity row). CSS-toggled (not isMobile) so it
           always tracks the same breakpoint as the drawer/bar layout. -->
      <div class="account-mobile d-lg-none">
        <div class="account-theme">
          <small class="account-theme-label">Theme</small>
          <div class="jft-tabs jft-tabs-sm" role="group">
            <button type="button" class="jft-tab" [class.active]="themeService.currentTheme === 'light'"
              (click)="themeService.setTheme('light')">
              <ng-icon name="lucideSun" size="14"></ng-icon>
            </button>
            <button type="button" class="jft-tab" [class.active]="themeService.currentTheme === 'dark'"
              (click)="themeService.setTheme('dark')">
              <ng-icon name="lucideMoon" size="14"></ng-icon>
            </button>
          </div>
        </div>

        <!-- Same action as the desktop dropdown entry, but a distinct test id:
             both blocks are always in the DOM (only CSS hides one), so a shared
             id would make Playwright's strict-mode locator ambiguous. -->
        <a *ngIf="uiVersion.canSwitch()" class="nav-link" data-testid="switch-to-v2-mobile"
          (click)="switchToV2()">Use the New Version</a>

        <ng-container *ngIf="company.isBuyer() && switchCompanies.length">
          <div class="account-switch-label">Switch Profile</div>
          <a *ngFor="let item of switchCompanies" class="nav-link" (click)="switchProfile(item.id)">{{ item.name }}</a>
        </ng-container>

        <!-- Identity + logout, pinned to the very bottom. Tapping the name
             opens the account edit page; Sign Out is the logout icon. -->
        <div class="account-identity">
          <a routerLink="/account/user" routerLinkActive="active" class="account-identity-main">
            <div *ngIf="!user.logo" class="fa-stack account-avatar">
              <i class="fas fa-square fa-stack-2x"></i>
              <i class="far fa-user fa-stack-1x fa-inverse"></i>
            </div>
            <div *ngIf="user.logo" class="avatar avatar-32 bg-white rounded account-avatar">
              <img src="{{ user.logo }}" alt="{{ user.firstName }} {{ user.lastName }}">
            </div>
            <div class="account-meta">
              <p class="navbar-user m-0 fw-normal">{{ user.firstName }} {{ user.lastName }}</p>
              <p class="navbar-company m-0">{{ company.name }}</p>
            </div>
          </a>
          <a routerLink="/access/logout" class="account-logout" title="Sign Out" aria-label="Sign Out">
            <i class="bi bi-box-arrow-right"></i>
          </a>
        </div>
      </div>

      <!-- Desktop: dropdown (unchanged), hidden below lg via CSS. -->
      <div ngbDropdown class="nav-item nav-userinfo d-none d-lg-block">
        <a ngbDropdownToggle class="nav-link dropdown-toggle pointer d-flex align-items-center justify-content-end">
          <div class="me-2">
            <p class="navbar-user m-0 text-white fw-normal text-end">{{ user.firstName }} {{ user.lastName }}</p>
            <p class="navbar-company m-0 text-end">{{ company.name }}</p>
          </div>
          <div *ngIf="!user.logo" class="fa-stack me-1">
            <i class="fas fa-square fa-stack-2x "></i>
            <i class="far fa-user fa-stack-1x fa-inverse"></i>
          </div>
          <div *ngIf="user.logo" class="avatar avatar-32 bg-white rounded me-1">
            <img src="{{ user.logo }}" alt="{{ user.firstName }} {{ user.lastName }}">
          </div>
        </a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
          <a class="dropdown-item" routerLink="/account/user" routerLinkActive="active">My Account</a>
          <div class="dropdown-divider"></div>
          <div class="px-3 py-2">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <small class="text-muted fw-medium">Theme</small>
            </div>
            <div class="jft-tabs jft-tabs-sm jft-tabs-full" role="group">
              <button type="button" class="jft-tab" [class.active]="themeService.currentTheme === 'light'"
                (click)="themeService.setTheme('light'); $event.stopPropagation()">
                <ng-icon name="lucideSun" size="14"></ng-icon>
              </button>
              <button type="button" class="jft-tab" [class.active]="themeService.currentTheme === 'dark'"
                (click)="themeService.setTheme('dark'); $event.stopPropagation()">
                <ng-icon name="lucideMoon" size="14"></ng-icon>
              </button>
            </div>
          </div>
          <div class="dropdown-divider"></div>
          <button *ngIf="uiVersion.canSwitch()" type="button" class="dropdown-item" data-testid="switch-to-v2"
            (click)="switchToV2()">Use the New Version</button>
          <a class="dropdown-item" routerLink="/access/logout">Sign Out</a>

          <ng-container *ngIf="company.isBuyer() && switchCompanies.length">
            <li>
              <hr class="dropdown-divider">
            </li>
            <a class="dropdown-item disabled" aria-disabled="true">Switch Profile</a>
            <a *ngFor="let item of switchCompanies;" class="dropdown-item"
              (click)="switchProfile(item.id)">{{item.name}}</a>
          </ng-container>
        </div>
      </div>
    </div>
    <ul *ngIf="!user.isAuthenticated()" class="navbar-nav ms-auto">
      <li class="nav-item">
        <a routerLink="/access/login" class="nav-link" routerLinkActive="active">
          Login
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/access/register" class="nav-link" routerLinkActive="active">
          Create Account
        </a>
      </li>
      <li class="nav-item pull-right">
        <a routerLink="/access/contact-support" class="nav-link" routerLinkActive="active"
           aria-label="Contact Support" title="Contact Support">
          <i class="fas fa-question-circle" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
  </div>
</nav>